export default __webpack_public_path__ + "static/media/ticket_2.1e060c03.svg";